export default __webpack_public_path__ + "static/logo-c05308995d8d202831f4b88a1b90dbc2.svg";